import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { OfficeSideSheetButton } from 'src/components/OfficeSidesheet/OfficeSidesheetButton/OfficeSidesheetButton';
import { getRoomLocation } from 'src/store/rooms/selectors';
import { sidesheetActions } from 'src/store/sidesheet/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export interface RoomOfficeSidesheetButtonProps {
  small?: boolean;
}

export const RoomOfficeSidesheetButton: FC<RoomOfficeSidesheetButtonProps> = ({
  small,
}) => {
  const dispatch = useAppDispatch();
  const { town, building, loading } = useSelector(getRoomLocation);

  const open = useCallback(() => {
    dispatch(sidesheetActions.open('roomOffice'));
  }, [dispatch]);

  return (
    <OfficeSideSheetButton
      onClick={open}
      town={town}
      building={building}
      disabled={loading}
      small={small}
    />
  );
};
